// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__yYy20","actionsCol":"EnrolledClinics_actionsCol__2nwEQ"};